import { render, staticRenderFns } from "./dyLisList_D.vue?vue&type=template&id=25dc3f70&scoped=true"
import script from "./dyLisList_D.vue?vue&type=script&lang=js"
export * from "./dyLisList_D.vue?vue&type=script&lang=js"
import style0 from "./dyLisList_D.vue?vue&type=style&index=0&id=25dc3f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc3f70",
  null
  
)

export default component.exports